<div *ngIf="showLegend" [ngSwitch]="layerCate">
	<div *ngSwitchCase="'ADDPTS'">
		<div class="legend-item">
			<div class="legend-point point-1">
			</div>
			<div>Valid</div>
		</div>
		<div class="legend-item">
			<div class="legend-point point-2">
			</div>
			<div>Warning</div>
		</div>
		<div class="legend-item">
			<div class="legend-point point-3">
			</div>
			<div>Critical</div>
		</div>
	</div>
	<div *ngSwitchCase="'ROADCL'">
		<div class="legend-item">
			<div class="legend-line line-1">
			</div>
			<div>Valid</div>
		</div>
		<div class="legend-item">
			<div class="legend-line line-2">
			</div>
			<div>Warning</div>
		</div>
		<div class="legend-item">
			<div class="legend-line line-3">
			</div>
			<div>Critical</div>
		</div>
	</div>
	<div *ngSwitchDefault>
		test
	</div>
</div>